import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import isEmpty from 'lodash/isEmpty';

import { activityActions } from '@share/store/slices';

import { SESSION_KEY_LABEL } from '@share/constants';

import { ISessionKey, IAccount } from '@share/common-types';

import { UrlUtils, getTimeout, LoginType, CanImpersonate, IsImpersonating, RootState, AppDispatch } from '@share/utils';


import { ActivitySearchForm } from '../search-form';
// AccessToken is unchanged from RSI's, so the shared one is reused.
import { AccessToken } from '../../search/access-token';
import { Impersonator } from '../../impersonator';


import './style.scss';

const zero = 0;

export const ActivitySearchWrapper: React.FC<any> = (props) => {
  const {
    borderRadius,
    isWidget,
    isExperiences,
    openOnClick,
    onSearch
  } = props;

  const dispatch = useDispatch<AppDispatch>();

  const loginStore = useSelector((State: RootState) => State.loginStore);

  const { account } = loginStore;



  useEffect(() => {

    const values = UrlUtils.getValues();
    const session: ISessionKey = values[SESSION_KEY_LABEL] as ISessionKey;

    if (session?.expireDate && getTimeout(session.expireDate) > zero) {
      dispatch(activityActions.setSessionKey(session));
    }
  }, []);

  const styleAccount: any = {};
  const mainStyle: any = {};

  const hasPublicAccessToken = account?.hasPublicAccessToken;
  const hasPublicValidToken = account?.type !== LoginType.Public || !hasPublicAccessToken || !isEmpty(loginStore.accessToken);

  if (!isEmpty(borderRadius)) {
    const b = parseInt(borderRadius);
    mainStyle.borderRadius = `${b}px`;
    styleAccount.borderRadius = `${b}px`;
  }

  return (
    <>
      <div className="activity-search-wrapper__wrapper">
        {(hasPublicValidToken || isWidget) && (
          <ActivitySearchForm isExperiences={isExperiences} openOnClick={openOnClick} onSearch={onSearch} />)}

        {!hasPublicValidToken && !isWidget &&
          <AccessToken />}
      </div>

      {CanImpersonate(account as IAccount) && !IsImpersonating() && (
        <div className="activity-search-wrapper__impersonate">
          <Impersonator />
        </div>)}
    </>

  )
};
